import { Banknote, BusFront, CircleAlert, MapPin, Users } from 'lucide-react'
import SourceStamp from '../components/SourceStamp'
import type { ProgramContent } from '../types/content'

interface GuideViewProps {
  program: ProgramContent
}

export default function GuideView({ program }: GuideViewProps) {
  return (
    <div className="view-stack">
      <section className="guide-intro">
        <p className="eyebrow">지원안내</p>
        <h2>{program.title}</h2>
        <p>{program.summary}</p>
      </section>

      <div className="guide-list">
        <article className="guide-card">
          <div className="guide-card__icon"><Users aria-hidden="true" /></div>
          <div><h3>지원 대상</h3><p>{program.eligibility.residency}</p><p>만 {program.eligibility.minimumAge}~{program.eligibility.maximumAge}세 어린이·청소년</p></div>
        </article>
        <article className="guide-card">
          <div className="guide-card__icon"><Banknote aria-hidden="true" /></div>
          <div><h3>지원 금액</h3><p>분기별 최대 {program.benefit.quarterlyMaximumWon.toLocaleString('ko-KR')}원</p><p>연간 최대 {program.benefit.annualMaximumWon.toLocaleString('ko-KR')}원</p><p>{program.benefit.paymentMethod}로 지급</p></div>
        </article>
        <article className="guide-card">
          <div className="guide-card__icon"><BusFront aria-hidden="true" /></div>
          <div><h3>지원 교통수단</h3><ul className="inline-list">{program.supportedTransport.map((item) => <li key={item}>{item}</li>)}</ul></div>
        </article>
        <article className="guide-card">
          <div className="guide-card__icon"><MapPin aria-hidden="true" /></div>
          <div><h3>신청과 거주지 확인</h3><p>분기별 신청</p><p>{program.application.residencyVerification}</p></div>
        </article>
        <article className="guide-card guide-card--warning">
          <div className="guide-card__icon"><CircleAlert aria-hidden="true" /></div>
          <div><h3>중복 지원 주의</h3><p>{program.duplicateSupportNotice}</p></div>
        </article>
      </div>

      <SourceStamp sourceName={program.sourceName} sourceUrl={program.sourceUrl} lastVerifiedAt={program.lastVerifiedAt} />
    </div>
  )
}

